import { environment } from './../../environments/environment';

export class ApiConstant {
    static baseUrl = environment.baseUrl;
    static baseAnalyzerUrl = environment.analyzer.baseUrl;
    
    // others API URLs
    static rfNews = environment.others.rfNewsUrl;
    // others API URLs
    
    static login = 'api/Users/token';

    static getCountries = ApiConstant.baseUrl + 'country/GetCountries/';

    static getCategories = ApiConstant.baseUrl + 'category/Get/';
    static getActiveCategories = ApiConstant.baseUrl + 'category/GetActiveCategories/';
    static getAllCategories = ApiConstant.baseUrl + 'category/GetAllCategory/';
    static addCategory = ApiConstant.baseUrl + 'category/AddCategory/';
    static editCategory = ApiConstant.baseUrl + 'category/EditCategory/';
    static activateCategory = ApiConstant.baseUrl + 'category/ActivateCategory/';
    static inactivateCategory = ApiConstant.baseUrl + 'category/InactivateCategory/';
    static moveUp = ApiConstant.baseUrl + 'category/MoveUp/';
    static moveDown = ApiConstant.baseUrl + 'category/MoveDown/';
    static deleteCategory = ApiConstant.baseUrl + 'category/DeleteCategory/';

    static getForms = ApiConstant.baseUrl + 'forms/GetForms/';
    static getFormCategories = ApiConstant.baseUrl + 'forms/GetFormCategories/';
    static getFormCategoryMaps = ApiConstant.baseUrl + 'forms/GetFormCategoryMaps/';
    static addForm = ApiConstant.baseUrl + 'forms/AddForm/';
    static editForm = ApiConstant.baseUrl + 'forms/EditForm/';
    static deleteForm = ApiConstant.baseUrl + 'forms/DeleteForm/';
    static orderUpForm = ApiConstant.baseUrl + 'forms/OrderUpForm/';
    static orderDownForm = ApiConstant.baseUrl + 'forms/OrderDownForm/';
    static formsReview = ApiConstant.baseUrl + 'forms/FormsReview/';

    static getRegulations = ApiConstant.baseUrl + 'regulations/GetRegulations/';
    static addRegulation = ApiConstant.baseUrl + 'regulations/AddRegulation/';
    static editRegulation = ApiConstant.baseUrl + 'regulations/EditRegulation/';
    static deleteRegulation = ApiConstant.baseUrl + 'regulations/DeleteRegulation/';
    static orderUpRegulation = ApiConstant.baseUrl + 'regulations/OrderUpRegulation/';
    static orderDownRegulation = ApiConstant.baseUrl + 'regulations/OrderDownRegulation/';
    static regulationsReview = ApiConstant.baseUrl + 'regulations/RegulationsReview/';

    static getNewsByLink = ApiConstant.baseUrl + 'news/GetNewsByLink/';
    static getRegfollowerNewsmapping = ApiConstant.baseUrl + 'news/GetRegfollowerNewsmapping/';
    static getNewsesByCountry = ApiConstant.baseUrl + 'news/GetNewsesByCountry/';
    static getNewsMapsByCountry = ApiConstant.baseUrl + 'news/GetNewsMapByCountry/';
    static deleteNewsMaps = ApiConstant.baseUrl + 'news/DeleteNewsMaps/';
    static updateRegfollowerNewsMapping = ApiConstant.baseUrl + 'news/UpdateRegfollowerNewsMapping/';

    static contentUpload = ApiConstant.baseUrl + 'Information/ContentUpload/';

    static getRegwireNews = ApiConstant.baseUrl + 'RegwireNews/GetRegwireNews/';
    static deleteRegwireNews = ApiConstant.baseUrl + 'RegwireNews/DeleteRegwireNews/';
    static updateRegwireNews = ApiConstant.baseUrl + 'RegwireNews/UpdateRegwireNews/';
    static synchronizeTheRegfollowerNews = ApiConstant.baseUrl + 'RegwireNews/SynchronizeRegfollowerNewsFromRssFeed/';

    static getCommentary = ApiConstant.baseUrl + 'Commentary/GetCommentary/';
    static saveSelection = ApiConstant.baseUrl + 'Commentary/SaveSelection/';
    static afterSaveSelectionPublishToRyans = ApiConstant.rfNews + 'Commentary/SyncWebhook/';
    static saveSelectionToAnalyzer = ApiConstant.baseAnalyzerUrl + 'Commentary/SaveSelection/';
    static saveDetailCategoryCommentaryMapping = ApiConstant.baseUrl + 'Commentary/SaveDetailCategoryCommentaryMapping/';
    static getAllCommentaryHeaderInfo = ApiConstant.baseUrl + 'Commentary/GetAllCommentaryHeaderInfo/';
    static getCommentaryContent = ApiConstant.baseUrl + 'Commentary/GetCommentaryContent/';
    static saveToCommentary = ApiConstant.baseUrl + 'Commentary/SaveToCommentary/';
    static saveToCommentaryToAnalyzer = ApiConstant.baseAnalyzerUrl + 'Commentary/SaveToCommentary/';
    static GetCommentaryUpdatedDate = ApiConstant.baseUrl + 'Commentary/GetCommentaryUpdatedDate';

    static getGuideline = ApiConstant.baseUrl + 'guideline/GetGuideline';
    static getGuidelineCategories = ApiConstant.baseUrl + 'guideline/GetGuidelineCategories';
    static batchPublish = ApiConstant.baseUrl + 'guideline/batchPublish';
    static batchUpload = ApiConstant.baseUrl + 'guideline/batchUpload';
    static mappingFileUpload = ApiConstant.baseUrl + 'guideline/mappingFileUpload';

    static addGuidelineCategory = ApiConstant.baseUrl + 'guideline/AddCategory';
    static editGuidelineCategory = ApiConstant.baseUrl + 'guideline/EditCategory';
    static activateGuidelineCategory = ApiConstant.baseUrl + 'guideline/ActivateCategory';
    static inactivateGuidelineCategory = ApiConstant.baseUrl + 'guideline/DeactivateCategory';
    static guideLineCategoryMoveUp = ApiConstant.baseUrl + 'guideline/MoveCategoryUp';
    static guideLineCategoryMoveDown = ApiConstant.baseUrl + 'guideline/MoveCategoryDown';
    static deleteguideLineCategory = ApiConstant.baseUrl + 'guideline/DeleteCategory';

    static caseLaw = ApiConstant.baseUrl + 'CaseLaw';
    // static saveCaseLaw = ApiConstant.baseUrl + 'CaseLaw/Save';
    static createCaseLaw = ApiConstant.baseUrl + 'CaseLaw/Create';
    static updateCaseLaw = ApiConstant.baseUrl + 'CaseLaw/Update';
    static deleteCaseLaw = ApiConstant.baseUrl + 'CaseLaw/Delete/';
    static caseLawAttachmentUpdate = ApiConstant.baseUrl + 'CaseLaw/Attachment/Update';

    static createCaseLawAnalyzer = ApiConstant.baseAnalyzerUrl + 'CaseLaw/Create';
    static updateCaseLawAnalyzer = ApiConstant.baseAnalyzerUrl + 'CaseLaw/Update';
    static deleteCaseLawAnalyzer = ApiConstant.baseAnalyzerUrl + 'CaseLaw/Delete/';
    static caseLawAttachmentUpdateAnalyzer = ApiConstant.baseAnalyzerUrl + 'CaseLaw/Attachment/Update';
    static syncCaseLawAttachmentsAnalyzer = ApiConstant.baseAnalyzerUrl + 'CaseLaw/Attachment/Sync';

    // Third-party provider news. Replaces the Regfollower feed and shares no constant with it.
    static getProviderNewsStatus = ApiConstant.baseUrl + 'ProviderNews/Status';
    static ingestProviderNews = ApiConstant.baseUrl + 'ProviderNews/Ingest';
}

